import { formatPayloadDate } from 'utils/helpers'

export const toAssignmentPayload = values => ({
  jobTitle: values.jobTitle,
  startDate: formatPayloadDate(values.startDate),
  ...(values.endDate && { endDate: formatPayloadDate(values.endDate) }),
  extensionPeriod: values.extensionPeriod * 30, // Convert months to days
  adAccount: values.adAccount,
  googleAccount: values.googleAccount,
  ldapAccount: values.ldapAccount,
  ...(values.details && { details: values.details }),
  ...(values.updateComment && { updateComment: values.updateComment }),
  person: {
    ...(values.partnerId && { id: values.partnerId }),
    ...(values.firstName && { firstName: values.firstName }),
    ...(values.lastName && { lastName: values.lastName }),
    ...(values.email && { email: values.email }),
    ...(values.phone && { phone: values.phone }),
    ...(values.details && { details: values.details }),
    isEnabled: true
  },
  manager: {
    id: values.manager.value
  },
  externalPartnerType: {
    id: values.externalPartnerType.value
  },
  legalEntity: {
    ...(values.legalEntityId && { id: values.legalEntityId }),
    ...(values.legalEntityName && { name: values.legalEntityName }),
    ...(values.legalEntityCIF && { code: values.legalEntityCIF }),
    ...(values.legalEntityCountry && { country: { id: values.legalEntityCountry.value } }),
    ...(values.legalEntityType && { legalEntityTypes: [{ id: values.legalEntityType.value }] }),
    isEnabled: true
  },
  ...(values.store && { stores: values.store.map(s => ({ id: s.value })) }),
  ...(values.delegate && { delegate: { id: values.delegate.value } }),
  status: { id: values.status },
  details: values.assignmentDetails
})
